import { memo, useSyncExternalStore } from 'react';
import { createDragPreview } from './MarkingLayer';
import { formatPrice } from './instruments';
import type { Symbol } from './instruments';

export const WickLoupe = memo(function WickLoupe({ store, symbol, width }: { store: ReturnType<typeof createDragPreview>; symbol: Symbol; width: number }) {
  const preview = useSyncExternalStore(store.subscribe, store.read, store.read);
  const lens = preview?.lens;
  if (!lens) return null;
  const { candle, anchor, snap, x: pointerX, y: pointerY, height } = lens;
  const w = 148, h = 136;
  const x = pointerX < width / 2 ? width - w - 8 : 8;
  const y = pointerY < height / 2 ? height - h - 32 : 12;
  const range = Math.max(candle.high - candle.low, Number.EPSILON);
  const py = (price: number) => 45 + (candle.high - price) / range * 62;
  const targetY = Math.max(39, Math.min(113, py(anchor.price)));
  const color = candle.close >= candle.open ? '#009944' : '#e53935';
  return <g data-testid="wick-loupe" data-export-ignore pointerEvents="none" transform={`translate(${x} ${y})`}>
    <rect width={w} height={h} rx="12" fill="#121b22" stroke="#c4a365" strokeWidth="1" />
    <text x="12" y="20" fill="#dcc18b" fontSize="9" fontWeight="700">{snap ? 'WICK PRECISION' : 'PRICE PRECISION'}</text>
    <text x={w - 12} y="20" textAnchor="end" fill="#a9b7c2" fontSize="9">{snap ? anchor.price === candle.high ? 'HIGH' : 'LOW' : 'FREE'}</text>
    <line x1="34" x2="34" y1={py(candle.high)} y2={py(candle.low)} stroke={color} strokeWidth="2" />
    <rect x="26" width="16" y={py(Math.max(candle.open, candle.close))} height={Math.max(2, Math.abs(py(candle.open) - py(candle.close)))} fill={color} />
    <line x1="18" x2="54" y1={targetY} y2={targetY} stroke="#f1d390" strokeWidth="2" />
    <text x="63" y="69" fill="#ffffff" fontSize="12" fontWeight="700">{formatPrice(symbol, anchor.price)}</text>
    <text x="63" y="86" fill="#a9b7c2" fontSize="8">LEPAS UNTUK LETAK</text>
    <text x="12" y="124" fill="#8295a2" fontSize="8">{new Date(candle.time).toISOString().slice(5, 16).replace('T', ' ')} UTC</text>
  </g>;
});
